import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareRoadmapRedirectRoute: InvariantJiraRoute = {
	name: 'software-roadmap-redirect',
	path: '/secure/Roadmap.jspa',
};
